import React from 'react'
import PropTypes from 'prop-types'

import { DashboardChartPaper, DonutChart } from 'components'

import theme from 'theme'

const UsersByConclusion = ({ trainings, id, ...rest }) => {
  const data = trainings?.reduce(
    (acc, department) => {
      acc[0] += department.certifiedPeople
      acc[1] += department.totalUsers - department.certifiedPeople

      return acc
    },
    [0, 0],
  )

  return (
    <DashboardChartPaper
      title="Comparação entre usuários treinados e não treinados"
      subtitle="Finalizaram o treinamento, não finalizaram o treinamento"
      heightContainer="fit-content"
      {...rest}
    >
      <DonutChart
        id={id}
        title="Treinamento"
        legendShow
        showName={false}
        names={['Finalizaram', 'Não Finalizaram']}
        values={data}
        colors={[
          theme.palette.dashboard.chart.training.concluded,
          theme.palette.dashboard.chart.training.notConcluded,
        ]}
      />
    </DashboardChartPaper>
  )
}

UsersByConclusion.propTypes = {
  trainings: PropTypes.array,
  id: PropTypes.string,
}

export default UsersByConclusion
